import React from "react";
import TableHeadFormik from "./TableHeadFormik";
import { CatalogueTableBodyFormik } from "./CatalogueTableBodyFormik";
import Table from "@mui/material/Table";
import { useFormikContext } from "formik";
import { Alert, Grid } from "@mui/material";
import { useState } from "react";
//import EnhancedTableToolbar from "./EnhancedTableToolbar";
function EnhancedTableToolbar(props) {
  const { name, label } = props;
  const { errors } = useFormikContext();
  // Only show total quantity error if this table has qty fields and its total is zero
  const tableTotals = (typeof window !== "undefined" && window.__tableTotals) || {};
  const showTotalQtyError = Boolean(
    errors[name + "_Total_Label"] &&
    tableTotals[name] &&
    tableTotals[name].hasQty === true &&
    tableTotals[name].totalZero === true
  );
  return (
    <>
      {errors[name + "_Label"] && (
        <Alert severity="error">
          <span> {errors[name + "_Label"]} </span>
        </Alert>
      )}
      {showTotalQtyError && (
        <Alert severity="error">
          <span> {errors[name + "_Total_Label"]} </span>
        </Alert>
      )}
      <u>
        <b>{label}:</b>
      </u>
    </>
  );
}

export function CatalogueTableFormik(props) {
  const [totalSum, setTotalSum] = useState(0);
  const [purchasedQty, setPurchasedQty] = useState([]);
  props = { ...props, purchasedQty, totalSum, setTotalSum, setPurchasedQty };

  return (
    <>
      <div className="tableformik">
        <EnhancedTableToolbar {...props} />
        <Grid maxWidth="sm">
          <Table>
            <TableHeadFormik {...props}></TableHeadFormik>
            <CatalogueTableBodyFormik {...props}></CatalogueTableBodyFormik>
          </Table>
        </Grid>
      </div>
    </>
  );
}
